import PricingBreakdown from "./PricingBreakdown";

function PricingSectionAwaitingApproval({ data }) {
  return (
    <div className="w-full border h-fit border-gray-200 rounded-xl overflow-hidden bg-white mt-4 p-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-900">Refund</h2>
        <span className="bg-[#FE9F29]/10 text-[#FE9F29] text-sm font-semibold px-3 py-1 rounded-md">
          Awaiting Airline Submission
        </span>
      </div>

      {/* Content */}
      <div className="bg-primary1/5 p-4 text-sm text-gray-700">
        {/* Per-passenger sections */}
        <PricingBreakdown data={data} />
      </div>
      {/* <div className="w-full flex flex-col gap-1 mt-4">
        <span className="font-bold text-sm">Note:</span>
        <span className="text-xs">
          Kindly note that the final refund price will be calculated by Airline
          when processing the refund. If you have any questions about the price,
          feel free to request refund pricing for manual verification.
        </span>
      </div> */}
    </div>
  );
}

export default PricingSectionAwaitingApproval;
